import ContentMenu from './ContentMenu'

export default ContentMenu
